import React from "react"
import { useHookstate } from "@hookstate/core"
import { Col, Row } from "react-bootstrap"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import { getElementFieldValue, makeSetHandler } from "../../globalStates/utils"
import Section from "../../components/Section"
import TextSocial from "../../components/Field/TextSocial"
import FacebookIcon from "../../images/facebook.svg"
import InstagramIcon from "../../images/instagram.svg"
import LinkedinIcon from "../../images/linkedin.svg"
import XingIcon from "../../images/xing.svg"
import XIcon from "../../images/x.svg"
import YoutubeIcon from "../../images/youtube.svg"
import PinterestIcon from "../../images/pinterest.svg"
import TikTokIcon from "../../images/tiktok.svg"
import { SocialMediaType } from "../../branding/branding"

const SocialMediaSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organizationState = useExhibitorDataState().getOrganization()
    const organization = useHookstate(organizationState)
    const itemsOrder = branding.configuration.profilePage.sctSocialMedia.itemsOrder

    return (
        <Section id="companySocialMedia" title={branding.configuration.profilePage.sctSocialMedia.lblSocialMedia}>
            <Row>
                {itemsOrder.map((item: SocialMediaType) => {
                    switch (item) {
                        case SocialMediaType.FACEBOOK:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="facebook"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblFacebook}
                                        icon={FacebookIcon}
                                        value={getElementFieldValue(organization, "facebook")}
                                        onChange={makeSetHandler(organization, "facebook")}
                                    />
                                </Col>
                            )
                        case SocialMediaType.INSTAGRAM:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="instagram"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblInstagram}
                                        icon={InstagramIcon}
                                        value={getElementFieldValue(organization, "instagram")}
                                        onChange={makeSetHandler(organization, "instagram")}
                                    />
                                </Col>
                            )
                        case SocialMediaType.LINKEDIN:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="linkedIn"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblLinkedIn}
                                        icon={LinkedinIcon}
                                        value={getElementFieldValue(organization, "linkedIn")}
                                        onChange={makeSetHandler(organization, "linkedIn")}
                                    />
                                </Col>
                            )
                        case SocialMediaType.XING:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="xing"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblXing}
                                        icon={XingIcon}
                                        value={getElementFieldValue(organization, "xing")}
                                        onChange={makeSetHandler(organization, "xing")}
                                    />
                                </Col>
                            )
                        case SocialMediaType.TWITTER:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="x"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblX}
                                        icon={XIcon}
                                        value={getElementFieldValue(organization, "twitter")}
                                        onChange={makeSetHandler(organization, "twitter")}
                                    />
                                </Col>
                            )
                        case SocialMediaType.YOUTUBE:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="youTube"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblYouTube}
                                        icon={YoutubeIcon}
                                        value={getElementFieldValue(organization, "youTube")}
                                        onChange={makeSetHandler(organization, "youTube")}
                                    />
                                </Col>
                            )
                        case SocialMediaType.PINTEREST:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="pinterest"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblPinterest}
                                        icon={PinterestIcon}
                                        value={getElementFieldValue(organization, "pinterest")}
                                        onChange={makeSetHandler(organization, "pinterest")}
                                    />
                                </Col>
                            )
                        case SocialMediaType.TIKTOK:
                            return (
                                <Col xs={6} key={item}>
                                    <TextSocial
                                        name="tiktok"
                                        label={branding.configuration.profilePage.sctSocialMedia.lblTikTok}
                                        icon={TikTokIcon}
                                        value={getElementFieldValue(organization, "tiktok")}
                                        onChange={makeSetHandler(organization, "tiktok")}
                                    />
                                </Col>
                            )
                        default:
                            return null
                    }
                })}
            </Row>
        </Section>
    )
}
export default SocialMediaSection
